import React from "react";
import { useNavigate } from "react-router-dom";
import pageNotFoundImage from "./../../assets/image/404-2.png";
import notFound from "./../../assets/image/Group.png";

const PageNotFound = () => {
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 flex flex-col-reverse lg:flex-row md:gap-28 gap-16 items-center justify-center">
      <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
        <div className="relative">
          <div className="absolute">
            <h1 className="my-2 text-gray-800 font-bold text-2xl">
              Looks like you've found the doorway to the great nothing
            </h1>
            <p className="my-2 text-gray-800">
              Sorry about that! Please visit our homepage to get where you need to go.
            </p>
            <button 
              onClick={redirectToHome}
              className="sm:w-full lg:w-auto my-2 border rounded py-4 px-8 text-center bg-[#045de8] text-white hover:bg-[#045de8] focus:outline-none focus:ring-2 focus:ring-[#045de8] focus:ring-opacity-50"
            >
              Take me there!
            </button>
          </div>
          <img src={pageNotFoundImage} alt="Page not found" />
        </div>
      </div>
      <div>
        <img src={notFound} alt="Group" />
      </div>
    </div>
  );
};

export default PageNotFound;
